export const   clearPayoutFlow= '[PAYOUTS FLOW] CLEAR'
export const   resetPayoutFlow= '[PAYOUTS FLOW] RESET'
export const   setPayoutFlowStep= '[PAYOUTS FLOW] SET STEP'
export const   toggleAddPayoutDialog= '[PAYOUTS FLOW ADD DIALOG] TOGGLE'
export const   addPayoutAccount= '[PAYOUTS] ADD ACCOUNT'
export const   deletePayoutAccount= '[PAYOUTS] DELETE ACCOUNT'
export const   setDefaultPayoutAccount= '[PAYOUTS] SET DEFAULT ACCOUNT'
export const   paymentConfigsFetched= '[PAYMENT CONFIGS] FETCHED'
export const   fetchPayemntConfigs= '[PAYMENT CONFIGS] GET'
